import { useState, useEffect } from 'react';
import { COMPACT_LAYOUT_BREAKPOINT } from '../config/constants.js';

/**
 * タブレット含むコンパクトレイアウト（max-width: 1024px）
 */
export function useIsCompactLayout() {
  const [isCompact, setIsCompact] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= COMPACT_LAYOUT_BREAKPOINT : false
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COMPACT_LAYOUT_BREAKPOINT}px)`);
    const handler = (e) => setIsCompact(e.matches);
    handler(mql);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isCompact;
}
